import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../baseDialog/BaseDialog";
import { Form } from "react-bootstrap";

import "./ShowSecretsDialog.css"

const ShowSecretsDialog = props => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    noFooter={true}
    title={(
      <div>
        {props.title}
      </div>
    )}
    body={(
      <div>
          <Form.Group className="mb-3">
              <Form.Label>{props.secretLabel}</Form.Label>
              <Form.Control disabled value={props.secret} className="secret-font" />
          </Form.Group>
      </div>
    )}
  />
);

export default withTranslation()(ShowSecretsDialog);
